import React from 'react'
import styles from './ActiveTest.module.scss'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Store from 'Stores'

const ActiveTest = ({
  study_test,
  name,
  test_level,
  test_sub_level,
  date_from,
  date_until,
  start_at,
  finish_at,
  questions_count,
  translate,
  id,
}) => {
  const isClient = Store.isClient
  const isTeacher = Store.isTeacher
  const isAdmin = Store.isAdmin
  const menu = [
    { name: translate?.variant_1, action: 'edit' },
    { name: translate?.variant_2, action: 'delete' },
  ]
  const action = (actionType) => {
    switch (actionType) {
      case 'delete':
        break
      case 'edit':
        break
      default:
        break
    }
  }

  return (
    <div className={styles.row}>
      <div className={`${styles.titleBox}`}>
        <div className={styles.subtitleRow}>
          {isClient ? (
            <span>
              {' '}
              {test_level} | {test_sub_level}{' '}
            </span>
          ) : (
            <>
              {(study_test?.sub_lvl?.lvl?.name || study_test?.sub_lvl?.name) &&
                `${study_test?.sub_lvl?.lvl?.name || ''} ${
                  study_test?.sub_lvl?.lvl?.name && study_test?.sub_lvl?.name
                    ? '|'
                    : ''
                } ${study_test?.sub_lvl?.name || ''}`}
            </>
          )}
        </div>
        <Link
          className={styles.linkWrapper}
          to={isAdmin ? `/study/test/${id}` : `/study/my-test/${id}`}
        >
          <div className={styles.title}>{name}</div>
        </Link>
      </div>
      <div className={`${styles.questionBox}`}>
        {translate?.questions}: {questions_count}
      </div>
      <div className={`${styles.dateBox}`}>
        <div className={styles.date}>
          <b>{start_at}</b>, {timeConverter(date_from, 'clean_data')}
        </div>
        <div className={styles.date}>
          <b>{finish_at}</b>, {timeConverter(date_until, 'clean_data')}
        </div>
      </div>
      <div className={styles.badgeWrapper}>
        <SuperButton variant='badge' type={'badgeColored'}>
          {translate?.in_progress}
        </SuperButton>
      </div>
      <div className={styles.btnBox}>
        <SuperButton
          variant='link'
          type='linkColored'
          path={isAdmin ? `/study/test/${id}` : `/study/my-test/${id}`}
        >
          {translate?.go_to_testing}
        </SuperButton>
        {!isClient && <ActionMenu menu={menu} action={action} />}
      </div>
    </div>
  )
}

export default ActiveTest
